// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Erectile dysfunction (INITIAL) 09.17.26" (1dcb779e-562e-4b69-9242-e20afe682f65). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiErectileDysfunctionInitialAnswerField } from './questions';

export const mdiErectileDysfunctionInitial: FormType<mdiErectileDysfunctionInitialAnswerField> =
  {
    name: 'Erectile dysfunction (INITIAL)',
    validityLength: 25,
    questions: [
      'mdiErectileDysfunctionInitial_longIssuesSexualPerformance',
      'mdiErectileDysfunctionInitial_medicationsDevicesTried',
      'mdiErectileDysfunctionInitial_redFlagsApply',
      {
        key: 'mdiErectileDysfunctionInitial_redFlagConditions',
        next: {
          condition: {
            'mdiErectileDysfunctionInitial_redFlagConditions.pulmonary_hypertension':
              true
          },
          key: 'mdiErectileDysfunctionInitial_selectedPulmonaryHypertensionSureDiagnosis',
          els: 'mdiErectileDysfunctionInitial_withinPast6MonthsHeart'
        }
      },
      'mdiErectileDysfunctionInitial_selectedPulmonaryHypertensionSureDiagnosis',
      {
        key: 'mdiErectileDysfunctionInitial_withinPast6MonthsHeart',
        next: {
          condition: {
            'mdiErectileDysfunctionInitial_withinPast6MonthsHeart.yes_ive_had_a_recent_heart_attack_or_car':
              true
          },
          key: 'mdiErectileDysfunctionInitial_tellUsMoreAboutHappened',
          els: 'mdiErectileDysfunctionInitial_everPhysicalAbnormalitiesGenitals'
        }
      },
      'mdiErectileDysfunctionInitial_tellUsMoreAboutHappened',
      'mdiErectileDysfunctionInitial_everPhysicalAbnormalitiesGenitals',
      {
        key: 'mdiErectileDysfunctionInitial_historyKidneyFailure',
        next: {
          switch: [
            {
              condition: {
                'mdiErectileDysfunctionInitial_historyKidneyFailure.history_of_kidney_failure_kidney_disease':
                  true
              },
              key: 'mdiErectileDysfunctionInitial_labTestsWithinPast6'
            },
            {
              condition: {
                'mdiErectileDysfunctionInitial_labTestsWithinPast6.yes': true
              },
              key: 'mdiErectileDysfunctionInitial_uploadLabResults'
            },
            {
              condition: {
                'mdiErectileDysfunctionInitial_historyKidneyFailure.have_seen_a_kidney_specialist_nephrologi':
                  true
              },
              key: 'mdiErectileDysfunctionInitial_describeReasonsConsultationRenalKidney'
            }
          ],
          els: 'mdiErectileDysfunctionInitial_usedPast3Months'
        }
      },
      {
        key: 'mdiErectileDysfunctionInitial_labTestsWithinPast6',
        next: {
          switch: [
            {
              condition: {
                'mdiErectileDysfunctionInitial_labTestsWithinPast6.yes': true
              },
              key: 'mdiErectileDysfunctionInitial_uploadLabResults'
            },
            {
              condition: {
                'mdiErectileDysfunctionInitial_historyKidneyFailure.have_seen_a_kidney_specialist_nephrologi':
                  true
              },
              key: 'mdiErectileDysfunctionInitial_describeReasonsConsultationRenalKidney'
            }
          ],
          els: 'mdiErectileDysfunctionInitial_usedPast3Months'
        }
      },
      {
        key: 'mdiErectileDysfunctionInitial_uploadLabResults',
        next: {
          switch: [
            {
              condition: {
                'mdiErectileDysfunctionInitial_labTestsWithinPast6.yes': true
              },
              key: 'mdiErectileDysfunctionInitial_provideDetailsMostRecentLab'
            },
            {
              condition: {
                'mdiErectileDysfunctionInitial_historyKidneyFailure.have_seen_a_kidney_specialist_nephrologi':
                  true
              },
              key: 'mdiErectileDysfunctionInitial_describeReasonsConsultationRenalKidney'
            }
          ],
          els: 'mdiErectileDysfunctionInitial_usedPast3Months'
        }
      },
      {
        key: 'mdiErectileDysfunctionInitial_provideDetailsMostRecentLab',
        next: {
          condition: {
            'mdiErectileDysfunctionInitial_historyKidneyFailure.have_seen_a_kidney_specialist_nephrologi':
              true
          },
          key: 'mdiErectileDysfunctionInitial_describeReasonsConsultationRenalKidney',
          els: 'mdiErectileDysfunctionInitial_usedPast3Months'
        }
      },
      'mdiErectileDysfunctionInitial_describeReasonsConsultationRenalKidney',
      'mdiErectileDysfunctionInitial_usedPast3Months',
      'mdiErectileDysfunctionInitial_takeMedications',
      {
        key: 'mdiErectileDysfunctionInitial_everPrescribedNitratesNitroglycerin',
        next: {
          condition: {
            'mdiErectileDysfunctionInitial_everPrescribedNitratesNitroglycerin.yes':
              true
          },
          key: 'mdiErectileDysfunctionInitial_provideMuchDetailPossibleLast',
          els: 'mdiErectileDysfunctionInitial_vitalsTestedMedicalPractitionerPast'
        }
      },
      'mdiErectileDysfunctionInitial_provideMuchDetailPossibleLast',
      'mdiErectileDysfunctionInitial_vitalsTestedMedicalPractitionerPast',
      'mdiErectileDysfunctionInitial_bloodPressureAverageDayEven',
      'mdiErectileDysfunctionInitial_importantClickAttachedLinkReview',
      'mdiErectileDysfunctionInitial_heresFirstMessageDoctorIntroduce',
      'mdiErectileDysfunctionInitial_complete'
    ]
  };
